module.exports = function(service) {
	'use strict'
	service.factory('watchAllCheckboxesNgTable',watchAllCheckboxesNgTable);
	watchAllCheckboxesNgTable.$inject=[];
	function watchAllCheckboxesNgTable() {
        return {
            'watch': function(scope, ctrlAs, title, id) {
                scope.$watch(function(){
                    return ctrlAs.checkboxes.checked
                }, function(newValue, oldValue){
                    if (newValue!=oldValue) {
                        ctrlAs.checkedPostsEdit = [];
                        var idProp = '_id'
                        if(id) {
                            idProp = id
                        }
                        if(newValue) {
                            if(ctrlAs.dataGet) {
                                for (var i=0; i<ctrlAs.dataGet.length; i++){
                                    if(!ctrlAs.dataGet[i].lock || Object.keys(ctrlAs.dataGet[i].lock).length == 0) {
                                        ctrlAs.checkboxes.items[ctrlAs.dataGet[i][idProp]] = true;
                                        if(title) {
                                            ctrlAs.checkedPostsEdit.push(ctrlAs.dataGet[i]);
                                        } else {
                                            ctrlAs.checkedPostsEdit.push(ctrlAs.dataGet[i][idProp]);
                                        }
                                    }
                                }
                                console.log(ctrlAs.checkboxes.items);
                            }
                        } else {
                            ctrlAs.checkboxes.items = {}
                            if(title) {
                                ctrlAs.cancelBulkEdit()
                            }
                        }
                    }
                },true);
            },
            resetCheckBox: function(ctrlAs) {
                ctrlAs.checkboxes.checked = false;
                ctrlAs.checkboxes.items = {};
                ctrlAs.checkedPostsEdit = [];
            }
        }
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/watchAllCheckboxesNgTableService.js
// module id = 631
// module chunks = 0